export function LaborUnion() {
  return <div>LaborUnion Works</div>;
}
